/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button } from '@coursera/cds-core';

import useIOSInfo from 'bundles/composable-page-header/hooks/useIOSInfo';

const styles = {
  stickyFooter: css`
    z-index: 1000;
    position: fixed;
    background-color: var(--cds-color-white-0);
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    padding: var(--cds-spacing-150) var(--cds-spacing-200);
  `,
};

const GetAppMenuItem = () => {
  const iosButtonInfo = useIOSInfo();

  if (!iosButtonInfo) {
    return null;
  }
  return (
    <div css={styles.stickyFooter} className="get-app-footer">
      <Button
        variant="secondary"
        size="medium"
        iconPosition="before"
        component="a"
        href={iosButtonInfo.href}
        edgeAlign="start"
        role="menuitem"
        fullWidth
      >
        {iosButtonInfo.label}
      </Button>
    </div>
  );
};

export default GetAppMenuItem;
